import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
// /import Select from "@mui/material/Select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchImg from "../../Assets/AppComponent/Vector (33).svg";
import createImg from "../../Assets/AppComponent/Arrow/Vector (3).png";

import { useTable, useSortBy, usePagination, useFilters, useGlobalFilter } from "react-table";

import { useMemo, useState } from "react";
import "../../StyleSheet/AppComponent/ReactTable/ReactTable.scss";
import Select from "react-select";
import boximg from "../../Assets/AppComponent/Group 427320177.svg";


var pageindexloc;

const DepartmentTables = (props) => {
    const {
        MakeCreate,
        Filter,
        Search,
        NoFilter,
        Nodatarecord,
        LevelUsersSelectedTable
    } = props;
    const columns = useMemo(() => props.columns);
    const data = props.data;

    const sateusers = useSelector((sateusers) => sateusers);

    ////---Get--sub role--
    const [SubRoleList, setSubRoleList] = useState();

    useEffect(() => {
        if (sateusers.users.UserData.data != undefined) {
        }
        if (sateusers.users.UserData.session) {
            if (
                sateusers.users.UserData.data != undefined &&
                sateusers.users.UserData.data != null
            ) {
                setSubRoleList(sateusers.users.UserData.data.sub_role);
            }
        }
    }, [sateusers.users]);


    const HandleView = (row) => {
        if (MakeCreate) {
            props.ViewParts(row);
        }
    };
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        rowsPerPage,
    } = useTable({
        columns,
        data,
    });

    const tableInstance = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: props.dtpageindex,
                pageSize: props.dtpagesize,
            },
            manualPagination: true,
            pageCount:
                props.datacount < 20 || props.datacount == null
                    ? 1
                    : Math.ceil(props.datacount / props.dtpagesize + 1),
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,

    );
    const {
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        state,
        visibleColumns,
        setGlobalFilter,
        preGlobalFilteredRows,
        previousPage,
        setPageSize,

        state: { pageIndex, pageSize },
    } = tableInstance;

    const [goPage, setGoPage] = useState(1);


    const [searchQuery, setSearchQuery] = useState("");

    const handlesearch = (e) => {
        props.onChange(e.target.value);
        setSearchQuery(e.target.value);
        if (props.id === "spe" || props.id === "sym") {
            props.setsno(0);
        }
    };

    const handleNext = (e) => {
        props.onNextpage(pageIndex);
    };
    const HandlePrevious = (e) => {
        props.onPrevious(e);
    };




    const handleGotoPage = (e) => {
        e.preventDefault();
    };
    const GotoThePage = () => {
        const goPageNumber = Number(goPage);
        console.log(
            goPageNumber,
            "goPageNumber",
            Math.ceil(
                props.datacount == null ? 1 : props.datacount / props.dtpagesize
            ),
            pageIndex == Math.ceil(props.datacount / props.dtpagesize),
            pageIndex
        );

        if (
            Math.ceil(
                props.datacount == null ? 1 : props.datacount / props.dtpagesize
            ) >= goPageNumber ||
            goPageNumber == ""
        ) {
            if (props.id === "spe" || props.id === "sym") {
                // props.setsno((newPageIndex - 1) * 20);
                props.setsno((goPageNumber - 1) * 20); // Set sno based on the page number
            }
            gotoPage(goPageNumber);
            props.GotoEnteredPage(goPageNumber);
        } else {
            toast.error("Invalid Page Number", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };


    const statusTabs = ['L1', 'L2', 'L3'];
    const HandletheActived = (e) => {
        props.HandletheActived(e)
    }

    console.log("Table Data:", data); // Debugging

    return (
        <>
            <>
                <div className="row no-zoom DepartmentTableCards">
                    <div className="col-md-12">
                        <div className="card" style={{padding:"18px 0px", borderRadius:"13px"}}>
                            <div className="card-body" style={{ padding: "1.5rem" }}>
                                <>
                                    {
                                        Filter ? (

                                            <>
                                                {/* -----------------Filters------------------ */}
                                                <div
                                                    className={`row tableFilter FilterManagement TicketTablesDepartments ${NoFilter ? "placeArange" : "notarange"
                                                        }`}
                                                    style={{
                                                        display: "flex",
                                                        alignContent: "center",
                                                        top: "-15px",
                                                        display: "flex",
                                                        position: "  relative",
                                                    }}
                                                >


                                                    <div className="tabs">
                                                        {statusTabs.map(tab => (
                                                            <button
                                                                key={tab}
                                                                className={`tab ${LevelUsersSelectedTable === tab ? 'active' : ''}`}
                                                                onClick={() => {
                                                                    HandletheActived(tab)
                                                                }}
                                                            >
                                                                {tab}
                                                            </button>
                                                        ))}
                                                    </div>

                                                    {!Search || Search == undefined ? (
                                                        <div
                                                            className={`field-div    ${NoFilter == true
                                                                ? "placeArangesearch"
                                                                : "notarangesearch"
                                                                }`}
                                                        >
                                                            <label
                                                                for="validationCustom02"
                                                                class="form-label FilterLabel"
                                                            ></label>

                                                            <div className="inputSearchFiled">

                                                                <span
                                                                    class="border-0  bg-transparent"
                                                                    id="search-addon"
                                                                >
                                                                    <img
                                                                        src={SearchImg}
                                                                        width="100%"
                                                                        height="100%"
                                                                    />
                                                                </span>
                                                                <input
                                                                    type="search"
                                                                    class=" TableSearch form-control "
                                                                    placeholder="Search..."
                                                                    onChange={handlesearch}
                                                                    value={searchQuery}
                                                                />

                                                            </div>
                                                        </div>
                                                    ) : null}




                                                </div>
                                            </>
                                        ) : null
                                    }
                                </>
                                <div className="table-responsive">
                                    <div className="INNERTABLE">
                                        <table {...getTableProps()} className="TableDesgin">
                                            <thead>
                                                {headerGroups.map((headerGroup) => (
                                                    <tr
                                                        {...headerGroup.getHeaderGroupProps()}
                                                        className="innerHead"
                                                    >
                                                        {headerGroup.headers.map((column) => (
                                                            <th {...column.getHeaderProps()}>
                                                                {column.render("Header")}

                                                             

                                                            </th>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </thead>

                                            {data != undefined &&
                                                page.length > 0 &&
                                                data.length > 0 ? (
                                                <tbody {...getTableBodyProps()} className="tbodyReact">
                                                    {page.map((row) => {
                                                        prepareRow(row);
                                                        return (
                                                            <tr
                                                                {...row.getRowProps()}
                                                                className={`InnerBodyTR ${MakeCreate ? "Cursor" : ""
                                                                    }`}
                                                                onClick={(e) => HandleView(row.original)}
                                                            >
                                                                {row.cells.map((cell) => {
                                                                    return (
                                                                        <td {...cell.getCellProps()}>
                                                                            {cell.render("Cell")}
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            ) : (
                                                <>
                                                </>
                                            )}


                                        </table>
                                        <>
                                            {data != undefined &&
                                                page.length > 0 &&
                                                data.length > 0 ?
                                                <>
                                                </>
                                                : <>
                                                    <div>

                                                        <div className="Dusbinbacktabls">

                                                            <div>
                                                                <img src={boximg} />
                                                                <p className="text-center">
                                                                    {Nodatarecord != undefined ? Nodatarecord : "No Data Available"}
                                                                </p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </>
                                    </div>
                                    <div
                                        className="row"
                                        style={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            margin: "0",
                                        }}
                                    >
                                        {props.datacount > 20 ? (
                                            <div
                                                className="pagination"
                                                style={{ justifyContent: "end", width: "100%" }}
                                            >
                                                <div
                                                    className=" pagination"
                                                    style={{ justifyContent: "end" }}
                                                >
                                                    <div className="showrow1" style={{ padding: "4px" }}>

                                                        <button
                                                            className="btn btn prim"
                                                            style={{ border: "none" }}
                                                            onClick={() => {
                                                                HandlePrevious(props.dtpageindex - 1);
                                                                // previousPage();
                                                                if (props.id == "spe" || props.id == "sym") {
                                                                    props.setsno(props.sno - 20);
                                                                }
                                                            }}
                                                            disabled={pageIndex == 1}
                                                        >
                                                            {"<"}
                                                        </button>
                                                        <span style={{ padding: "10px" }}>


                                                            <strong style={{ fontSize: "12px" }}>
                                                    
                                                                {pageIndex} of{" "}
                                                                {Math.ceil(
                                                                    props.datacount == null
                                                                        ? 1
                                                                        : props.datacount / props.dtpagesize
                                                                )}{" "}
                                                            </strong>
                                                        </span>

                                                        <button
                                                            style={{ border: "none" }}
                                                            className="btn btn prim"
                                                            onClick={() => {
                                                                // handleNext()
                                                                // nextPage();
                                                                handleNext(props.dtpageindex + 1);

                                                                if (props.id == "spe" || props.id == "sym") {
                                                                    props.setsno(props.sno + 20);
                                                                }
                                                            }}
                                                            disabled={
                                                                pageIndex ==
                                                                Math.ceil(props.datacount / props.dtpagesize)
                                                            }
                                                        >
                                                            {">"}
                                                        </button>
                                                        <span className="GOTOPageOuters">
                                                            <form
                                                                className="GotoPageForm"
                                                                onSubmit={handleGotoPage}
                                                            >
                                                                <span className="GotoPageText">Go to Page</span>
                                                                <input
                                                                    type="number"
                                                                    value={goPage}
                                                                    className="formcontrol_Table"
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const newPageIndex = e.target.value;
                                                                        console.log(
                                                                            newPageIndex,
                                                                            "newPageIndex",
                                                                            !isNaN(newPageIndex)
                                                                        );

                                                                        if (!isNaN(newPageIndex)) {
                                                                            // if (
                                                                            //   props.id === "spe" ||
                                                                            //   props.id === "sym"
                                                                            // ) {
                                                                            //   props.setsno((newPageIndex - 1) * 20);
                                                                            // }
                                                                            if (
                                                                                newPageIndex != 0 &&
                                                                                newPageIndex > 0
                                                                            ) {
                                                                                setGoPage(newPageIndex);
                                                                            } else if (
                                                                                newPageIndex == 0 ||
                                                                                newPageIndex < 0
                                                                            ) {
                                                                                setGoPage("");
                                                                            }
                                                                        }
                                                                    }}
                                                                    step="1"
                                                                    onKeyDown={(evt) => {
                                                                        if (
                                                                            ["e", "E", "+", "-", "."].includes(
                                                                                evt.key
                                                                            )
                                                                        ) {
                                                                            evt.preventDefault();
                                                                        }
                                                                    }}
                                                                />

                                                                <button
                                                                    type="submit"
                                                                    className="GOBTON btn"
                                                                    disabled={goPage == ""}
                                                                    onClick={(e) => {
                                                                        GotoThePage();
                                                                    }}
                                                                >
                                                                    Go
                                                                </button>
                                                            </form>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    );
};

export default DepartmentTables;
